<template>
  <div>
    <md-switch
      v-model="modelValue"
      @change="$emit('input', modelValue)"
      class="md-primary"
    ></md-switch>
  </div>
</template>

<script>
export default {
  name: "VpSwitch",
  props: {
    color: {
      type: String,
      default: "md-primary", // 'md-default' => red color
    },
    initialValue: {},
  },
  data: () => ({
    modelValue: false,
  }),
  mounted() {
    this.modelValue = this.initialValue;
  },
};
</script>

<style lang="scss">
.md-switch {
  display: flex;
}
.md-switch.md-theme-default .md-switch-container {
  // background-color: #f2f2f2 !important;
  background-color: #D1D1D1 !important;

}
.md-switch-thumb {
  background-color: #939393 !important;
}
.md-checked {
  .md-switch-thumb {
    background-color: #34c38f !important;
  }
}
</style>
